import React, { Component, Fragment } from 'react';
import {
  Scheduler,
  WeekView,
  MonthView,
  Appointments,
  AppointmentTooltip,
  DateNavigator,
  Toolbar,
} from '@devexpress/dx-react-scheduler-material-ui';
import { isEmpty } from "lodash"
import { Box, RadioGroup, Typography, Paper, IconButton } from '@mui/material';
import { ViewState } from '@devexpress/dx-react-scheduler';
import { SCHCOLORS } from '../../../utils/generalFuncs';
import AppointmentContent, {Appointment} from '../../common/TSElements/AppointmentContent';
import { GroupCheckbox, SingleCheckbox, SingleRadio } from '../../common/RadioAndCheckbox';
import { CloudDownloadRounded, EngineeringRounded, WorkHistory } from '@mui/icons-material';
import { InputSelectMulti } from '../../common/Form';

class ScheduleAdmin extends Component {
    state = { 
        currentViewName: "Month",
        types : {
            OTHER: true,
            PROJECT: true,
            CHANTIER: true,
            ABS: true,
        },
        // searchEmployee: {label: "", value: ""},
        searchEmployee: [],
        searchService: {label: "", value: ""}
    }
    componentDidMount = async () => {
        if(!this.props.STATE.projects.fetched){
            await this.props.fetchProjects()
        }
        if(!this.props.STATE.timesheets.fetched){
            await this.props.fetchTimesheets()
        }
        if(this.props.employeeID){
            this.setState({
                searchEmployee: [{label:"", value: this.props.employeeID}]
            })
        }
        // this.getList()
    }
    getList = () => {
        const { TIMESHEETS, EMPLOYEES, PROJECTS, projectID, chantierID } = this.props;
        let appointments = []
        Object.values(TIMESHEETS).forEach(element => {
            let tmp = Object.assign({}, element)
            if (projectID){
                if(tmp.project_id === projectID){
                    tmp.title = `${EMPLOYEES[tmp.timesheet_employee].employee_lastname} ${EMPLOYEES[tmp.timesheet_employee].employee_firstname}`
                    tmp.color = SCHCOLORS[tmp.event_type]
                    appointments.push(tmp)
                } 
            } else if (chantierID){
                if(tmp.timesheet_chantier === chantierID){
                    tmp.title = `${EMPLOYEES[tmp.timesheet_employee].employee_lastname} ${EMPLOYEES[tmp.timesheet_employee].employee_firstname}`
                    tmp.color = SCHCOLORS[tmp.event_type]
                    appointments.push(tmp)
                } 
            } else {
                if (tmp.event_type === "PROJECT") {
                    tmp.title = PROJECTS[tmp.project_id] && PROJECTS[tmp.project_id].project_name
                }
                tmp.color = SCHCOLORS[tmp.event_type]
                tmp.title = `${EMPLOYEES[tmp.timesheet_employee].employee_lastname} ${EMPLOYEES[tmp.timesheet_employee].employee_firstname} - `+ tmp.title
                appointments.push(tmp)
            }
        });
        // this.setState({appointments})
        console.log({appointments});
        return appointments
    }

    handleCheck = (event_type) => {
        let types = Object.assign({}, this.state.types) 
        types[event_type] = !types[event_type]
       
        this.setState({                
            types
        })
    }
    filterList = () => {
        const { types, searchEmployee, searchService } = this.state;
        const { EMPLOYEES, projectID, chantierID } = this.props;
        let checkedTypes = Object.keys(types).filter(eType => types[eType])
        console.log({checkedTypes});
        console.log({searchEmployee});

        let list = this.getList()
        if(!isEmpty(list)){

            list = list.filter(item => checkedTypes.includes(item.event_type))
            console.log({list});
    
            // if( !isEmpty(searchEmployee.value)) {
            //     list = list.filter( item => item.timesheet_employee === searchEmployee.value)
            // }
            // if( Array.isArray(searchEmployee) && !isEmpty(searchEmployee) ) {

                if (!projectID && !chantierID){
                    
                    let itemList = searchEmployee.map(item => item.value )
                    list = list.filter( item => itemList.includes(item.timesheet_employee))
                } else if( Array.isArray(searchEmployee) && !isEmpty(searchEmployee) ) {
                    let itemList = searchEmployee.map(item => item.value )
                    list = list.filter( item => itemList.includes(item.timesheet_employee))
                }


            // }
            if( Array.isArray(searchService) && !isEmpty(searchService) ) {
                let itemList = searchService.map(item => item.value )
                list = list.filter( item => itemList.includes(EMPLOYEES[item.timesheet_employee].employee_service))
            }
        }

        // this.setState({                
        //     appointments: list,
        // })
        // if(option){
        //     list = list.filter(item => item.timesheet_employee === option.value)
        //     this.setState({                
        //         appointments: list,
        //         searchEmployee: option,
        //         types
        //     })
        // } else {
        //     this.setState({
        //         appointments: list,
        //         searchEmployee: {label: "", value: ""},
        //         types
        //     })
        // }
        return list
    }

    handleChangeEmployee = (option) => {
        if(option){
            this.setState({                
                searchEmployee: option,
            })
        } else {
            this.setState({
                searchEmployee: [],
            })

        }
    }
    handleChangeService = (option) => {
        if(option){
            this.setState({                
                searchService: option,
            })
        } else {
            this.setState({
                searchService: {label: "", value: ""},
            })

        }
    }
    render() {
        const { currentViewName, types } = this.state;  
        const { EMPLOYEES, projectID, chantierID, employeeID, SERVICES } = this.props;  
        // let appointments = []
        let appointments = this.filterList()
        return (
            <Box>
                {!projectID && !chantierID &&
                    <Typography variant="h6" id="tableTitle">
                        Planning
                    </Typography>
                }
                
                <Box style={{ display: "flex", justifyContent: "space-between"}}>
                    <RadioGroup
                        aria-label="Vues"
                        style={{ flexDirection: 'row' }}
                        name="views"
                        value={currentViewName}
                        onChange={(e) => this.setState({ currentViewName: e.target.value})}
                    >
                        <SingleRadio value="Month" label="Mois"/>
                        <SingleRadio value="Week" label="Semaine"/>
                    </RadioGroup>
                    {!projectID && !chantierID &&
                        <GroupCheckbox>
                            <SingleCheckbox checked={types.PROJECT} label="Projets" color={SCHCOLORS.PROJECT} 
                                onChange={() => this.handleCheck("PROJECT") }
                            />
                            <SingleCheckbox checked={types.CHANTIER} label="Chantiers" color={SCHCOLORS.CHANTIER} 
                                onChange={() => this.handleCheck("CHANTIER") }
                            />
                            <SingleCheckbox checked={types.OTHER} label="Autre" color={SCHCOLORS.OTHER} 
                                onChange={() => this.handleCheck("OTHER") }
                            />
                            <SingleCheckbox checked={types.ABS} label="Congés" color={SCHCOLORS.ABS} 
                                onChange={() => this.handleCheck("ABS") }
                            />
                        </GroupCheckbox>
                       
                    }
                    {!projectID && !chantierID && !employeeID &&
                        <IconButton color="primary" onClick={() => this.props.openFormDownload("/extract/timesheets")} title="Télécharger" disabled={this.props.downloading}>
                            <CloudDownloadRounded />
                        </IconButton>
                    }
                    {employeeID &&
                        <IconButton color="primary" onClick={() => this.props.openFormDownload("/extract/timesheets/employee", employeeID)} title="Planning" disabled={this.props.downloading}>
                            <CloudDownloadRounded />
                        </IconButton>
                    }
                    {projectID &&
                        <Box>
                            <IconButton color="primary" onClick={() => this.props.openFormDownload("/extract/timesheets/employee", projectID)} title="Planning" disabled={this.props.downloading}>
                                <CloudDownloadRounded />
                            </IconButton>
                            <IconButton color="primary" onClick={() => this.props.openFormDownload("/extract/timesheets/project/MOD", projectID)} title="Hommes / Jour" disabled={this.props.downloading}>
                                <EngineeringRounded />
                            </IconButton>
                        </Box>
                    }
                </Box>
                { isEmpty(this.props.employeeID) &&
                    <Box style={{ display: "flex", justifyContent: "space-between"}}>
                        {!isEmpty(EMPLOYEES) &&
                            <Box style={{width: "100%"}}>
                                <InputSelectMulti
                                    label="Employé"
                                    id="searchEmployee"
                                    options={Object.values(EMPLOYEES).map( item => ({
                                        label: `${item.employee_matricule} - ${item.employee_lastname.toUpperCase()} ${item.employee_firstname}`,
                                        value: item.employee_id,
                                        disabled: Array.isArray(this.state.searchEmployee) && !!this.state.searchEmployee.find(element => element.value === item.employee_id)

                                    }))}
                                    value={this.state.searchEmployee}
                                    onChange={this.handleChangeEmployee}
                                    helperText={!this.props.projectID && !this.props.chantierID && "Selectionnez au moins 1 employé pour voir son planning"}
                                    isMulti
                                />
                            </Box>
                        }
                        {!isEmpty(SERVICES) && 
                            <Box style={{width: "100%"}}>
                                <InputSelectMulti
                                    label="Service"
                                    id="searchService"
                                    options={Object.values(SERVICES).map( item => ({
                                        label: `${item.service_name}`,
                                        value: item.service_id,
                                        disabled: Array.isArray(this.state.searchService) && !!this.state.searchService.find(element => element.value === item.service_id)

                                    }))}
                                    value={this.state.searchService}
                                    onChange={this.handleChangeService}
                                    isMulti
                                />
                            </Box>
                        }
                        
                        
                    </Box>
                }
                
                <Paper>
                    <Scheduler
                        data={appointments}
                        currentViewName={currentViewName}
                        locale={"fr-FR"}
                    >
                        <ViewState
                            defaultCurrentDate={new Date()}
                        />
                        {currentViewName === "Week" &&
                            <WeekView
                                startDayHour={7.5}
                                endDayHour={22.5}
                            />
                        }
                        {currentViewName === "Month" &&
                            <MonthView />
                        }
                        <Toolbar />
                        <DateNavigator />
                        <Appointments 
                            appointmentComponent={Appointment}
                        />
                        <AppointmentTooltip
                            contentComponent={AppointmentContent}
                            showCloseButton
                        />
                        {/* <AllDayPanel /> */}
                    </Scheduler>
                </Paper>
            </Box>
        );
    }
}

export default ScheduleAdmin;
